import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DEAL_CANDIDATES } from '@/lib/constants/api'
import getDealCandidateModel from './models/dealCandidate'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const dealCandidate = {
  namespaced: true,
  state: {
    ...getDealCandidateModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setDealCandidate: (state, user) => {
      state.id = user.id
      state.dealId = user.dealId
      state.existingUserId = user.existingUserId
      state.firstName = user.firstName
      state.lastName = user.lastName
      state.fullName = user.fullName
      state.emailAddress = user.emailAddress
    },
    clearDealCandidate: (state) => {
      state.id = null
      state.dealId = null
      state.candidateType = null
      state.existingUserId = null
      state.firstName = null
      state.lastName = null
      state.emailAddress = null
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_DEAL_CANDIDATES, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_DEAL_CANDIDATES, data: state })
    },
    getDealCandidate: ({ commit, dispatch }, { dealId }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting candidate, please wait...' })

      return api.doGet({ path: PATH_DEAL_CANDIDATES, parameters: { dealId } })
        .then(json => json.data)
        .then(data => Array.isArray(data) ? data[0] : data)
        .then(user => {
          commit('updateStatus', { status: COMPLETE })
          commit('clearDealCandidate')
          commit('setDealCandidate', user)
          return user
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveDealCandidate: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving candidate, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        if (!response.data) {
          if (response.errorMessage) {
            throw new Error(response.errorMessage)
          }
          throw new Error('Unable to save candidate. Check required fields.')
        }

        commit('updateStatus', { status: COMPLETE })
        notifySuccess(dispatch, 'Candidate saved')
        commit('setDealCandidate', response.data)
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, error || 'Unable to save candidate. Try again later')
        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearDealCandidate: ({ commit }) => {
      commit('clearDealCandidate')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default dealCandidate
